/**
 * Refactored by mariushirjanu on 10/11/2020.
 */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

/**
 * @ngdoc component
 * @name ga2.shared.collapseIndicator:collapseIndicator
 *
 * @description A directive for adding an icon if the element can be 'opened' or 'collapsed'. The icon has 2 states.
 *
 * @param {boolean} open indicates whether it should indicate a toggled state or not
 * @param {boolean=} [clickable=false] is this clickable?
 * @param {string=} linkName an optional link name
 * @param {Function=} onChange(collapsed) will be called when the collapse state is changed through clicking of the user
 */

@Component({
  selector: 'collapse-indicator',
  template: `    
    <i *ngIf="open" class="fa fa-caret-down collapse-indicator-open" (click)="onClick($event)"></i>
    <i *ngIf="!open" class="fa fa-caret-right collapse-indicator-closed" (click)="onClick($event)"></i>
    <a *ngIf="linkName" href (click)="onClick($event)" [innerHTML]="linkName"></a>
  `,
  styleUrls: ['./collapse-indicator.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CollapseIndicatorComponent {
  @Input() public linkName:string;
  @Input() public clickable:boolean;
  @Input() public open:boolean;
  @Output() public onChange:EventEmitter<boolean> = new EventEmitter();

  constructor() {
    /***/
  }

  public onClick(e:Event):void {
    e.preventDefault();
    if (this.clickable) {
      this.open = !this.open;
      this.onChange.emit(!this.open);
    }
  }
}